const currencyToConversion = (from: string, to: string) => `${from}_TO_${to}`;
export default currencyToConversion;
